<template>
  <div class="home-console">
    <a-row :gutter="16">
      <a-col :span="16">
        <a-card title="最近访问" class="mb16">
          <div class="empty-block">
            <a-empty description="暂无访问记录~">
              <template #image>
                <img src="https://img.icons8.com/ios/100/000000/opened-folder.png" style="width:80px;opacity:0.3;" />
              </template>
            </a-empty>
          </div>
        </a-card>
        <a-card title="我的资源" class="mb16">
          <a-tabs v-model:activeKey="tabKey">
            <a-tab-pane key="iot" tab="智联网">
              <div class="resource-list">
                <div class="resource-item blue">
                  <a-icon type="appstore" /> 智联网概况
                </div>
                <div class="resource-item blue">
                  <a-icon type="database" /> 设备管理
                </div>
                <div class="resource-item blue">
                  <a-icon type="branches" /> 协议网关
                </div>
                <div class="resource-item blue">
                  <a-icon type="file-protect" /> 协议脚本
                </div>
                <div class="resource-item blue">
                  <a-icon type="info-circle" /> 设备详情
                </div>
                <div class="resource-item blue">
                  <a-icon type="cloud-upload" /> ota升级
                </div>
                <div class="resource-item orange">
                  <a-icon type="appstore" /> 通用物模型
                </div>
                <div class="resource-item orange">
                  <a-icon type="appstore" /> 产品管理
                </div>
                <div class="resource-item blue">
                  <a-icon type="appstore" /> 产品品类
                </div>
              </div>
              <div style="text-align:right;margin-top:16px;">
                <a-button type="primary">进入模块</a-button>
              </div>
            </a-tab-pane>
            <a-tab-pane key="sys" tab="系统管理">
              <div class="empty-block">
                <a-empty description="暂无内容" />
              </div>
            </a-tab-pane>
            <a-tab-pane key="code" tab="低代码">
              <div class="empty-block">
                <a-empty description="暂无内容" />
              </div>
            </a-tab-pane>
            <a-tab-pane key="my" tab="我的物联">
              <div class="empty-block">
                <a-empty description="暂无内容" />
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-card>
        <a-card title="帮助文档">
          <div class="help-list">
            <a-button type="default" icon="file-text" class="help-btn">官方文档</a-button>
            <a-button type="default" icon="link" class="help-btn">开源地址</a-button>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card>
          <div class="user-block">
            <a-avatar size="large" style="background:#e6f7ff;color:#1890ff;"> <template #icon><user-outlined /></template> </a-avatar>
            <div class="user-info">
              <div style="font-weight:bold;font-size:16px;">administrator <a-icon type="copy" style="margin-left:4px;" /></div>
              <div style="color:#888;font-size:13px;">账号ID: 174035805703188544 <a-icon type="copy" style="margin-left:4px;" /></div>
              <a style="color:#1890ff;font-size:13px;">查看详情 <a-icon type="right" /></a>
            </div>
          </div>
        </a-card>
        <a-card style="margin-top:16px;">
          <a-tabs default-active-key="all">
            <a-tab-pane key="all" tab="全部消息">
              <div class="empty-block">
                <a-empty description="暂无数据" />
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
    <div class="footer">Powered by 迈睿达 Copyright 湖北迈睿达供应链股份有限公司</div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { UserOutlined } from '@ant-design/icons-vue'
const tabKey = ref('iot')
</script>

<style lang="less" scoped>
.home-console {
  background: #f5fafb;
  min-height: 100vh;
  padding: 24px 24px 0 24px;
  .mb16 { margin-bottom: 16px; }
  .resource-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    .resource-item {
      width: 160px;
      height: 48px;
      background: #f5f7fa;
      border-radius: 8px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      font-size: 15px;
      color: #333;
      cursor: pointer;
      &.blue { background: #e6f7ff; color: #1890ff; }
      &.orange { background: #fff7e6; color: #faad14; }
      a-icon { margin-right: 8px; }
      margin-bottom: 8px;
    }
  }
  .help-list {
    display: flex;
    gap: 16px;
    .help-btn { min-width: 120px; }
  }
  .user-block {
    display: flex;
    align-items: center;
    gap: 16px;
    .user-info { flex: 1; }
  }
  .empty-block {
    text-align: center;
    padding: 32px 0;
  }
  .footer {
    text-align: center;
    color: #888;
    margin: 32px 0 0 0;
    font-size: 14px;
  }
}
</style> 